import React from "react";
import TechNavbar from "../components/TechNavbar";
import Footer from "../components/Footer";
import FadeInSection from "../components/FadeInSection";
import GraphicDesignHero from "../components/GraphicDesign/GraphicDesignHero";
import UXsection from "../components/GraphicDesign/UXsection";
import ReBrandingSection from "../components/GraphicDesign/ReBrandingSection";
import MediaAndPrintSection from "../components/GraphicDesign/MediaPrintSection";

const GraphicDesign = () => {
  return (
    <div className="min-h-screen">
      <TechNavbar />

      {/* Hero Section */}
      <FadeInSection>
        <GraphicDesignHero />
      </FadeInSection>

      {/* UI/UX DESIGN SECTION */}
      <FadeInSection>
        <UXsection />
      </FadeInSection>

      {/* REBRANDING SECTION */}
      <FadeInSection>
        <ReBrandingSection />
      </FadeInSection>

      {/* BEYOND THE SCREEN */}
      <FadeInSection>
        <MediaAndPrintSection />
      </FadeInSection>

      {/* FOOTER  */}
      <Footer />
    </div>
  );
};

export default GraphicDesign;
